<template>
  <div class="columns is-mobile">
    <div class="column is-4 is-hidden-mobile"/>
    <div class="column is-narrow">
      <div class="title is-5">
        {{ Catalog.Total.Label }}
      </div>
    </div>
    <div class="column">
      <div class="has-text-right">
        <kst-value class="title is-5"
          field="Total" :data="userData" :catalog="Catalog"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Catalog from "../RrcvCatalog.js";

export default {
  props: {
    userData: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>